import { render, staticRenderFns } from "./CopyPaste.vue?vue&type=template&id=2c55377c"
import script from "./CopyPaste.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyPaste.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports